import { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col, Button, Container } from "reactstrap";
import PriceCard from "./priceCard";
import { useSelector } from "react-redux";
import { selectpriceTokens } from "store/selector/bestPriceCoins";
import { addComma } from "utils/Format";
import { getTokenInfo } from "utils/getters";
import { selectToken } from "store/selector/tokenStore";
import { logoOptions } from "constants/lotties";
import LottieLogo from "components/pages/lottie";
import {
  COINNIK_MARKET_BASE_TOKEN,
  COINNIK_MARKET_URL_BASE_TOKENS,
} from "configs/constants";
import iphone from "assets/image/iphone.png";
import "assets/styles/components/gutter.scss";
import "assets/styles/components/card.scss";

export default function SectionOne() {
  const { t } = useTranslation();
  const name = "Intermediary";
  const stateList = useSelector(selectpriceTokens);
  const tokens = useSelector(selectToken);
  const { tokenList } = stateList;
  useEffect(() => {}, [tokens]);
  return (
    <div className="py-5 bg-primary-one ">
      <Container className="mb-5">
        <Row className="d-flex flex-row justify-content-around ">
          <Col xs="12" sm="12" md="12" lg="6" xl="5">
            <h1 className="text-light fw-bold flip-animate position-relative text-nowrap pb-3 pt-2 mt-5 my-md-0 home-title-fs-mobile">
              <Trans i18nKey="DirectـTrading">
                Digital Currency
                <span className="text-warning-light" data-hover="بی واسطه">
                  {{ name }}
                </span>
                Trading Market
              </Trans>
            </h1>
            <p className="text-light">{t("Digital_currency_market")}</p>

            <Row className="d-flex align-items-center mt-5">
              <Col
                xs="12"
                md={12}
                lg="5"
                xl={5}
                className="d-flex justify-content-center "
              >
                <a
                  href={
                    COINNIK_MARKET_URL_BASE_TOKENS + COINNIK_MARKET_BASE_TOKEN
                  }
                >
                  <Button size="lg" color="warning">
                    {t("Enter the market")}
                  </Button>
                </a>
              </Col>
              <Col
                xs="12"
                md={12}
                lg="3"
                xl={3}
                className=" d-flex justify-content-center my-4 my-md-0"
              >
                <a href="#start" className="text-warning-light mx-1">
                  {t("How to start?")}
                </a>
              </Col>
            </Row>
          </Col>
          <Col
            xs="12"
            sm="12"
            lg="6"
            xl="7"
            className="d-flex justify-content-center position-relative coin-pricing-box"
          >
            <img src={iphone} className="style-phone-img" />
            {tokenList.length ? (
              <>
                <div className="right-center-token-price-card ">
                  <PriceCard
                    coinName={getTokenInfo("BTC", "localeName")}
                    tetherPrice={addComma(
                      Number(getTokenInfo("BTC", "bestBuy","TMN"))
                    )}
                    rateChange={getTokenInfo(
                      "BTC",
                      "change24Percentage"
                    ).toFixed(2)}
                    tomanPrice={`$${Number(getTokenInfo("BTC", "bestBuy"))}`}
                    imgSrc={getTokenInfo("BTC", "logoUrl64px")}
                  />
                </div>
                <div className="left-top-token-price-card">
                  <PriceCard
                    coinName={getTokenInfo("ETH", "localeName")}
                    tetherPrice={addComma(
                      Number(getTokenInfo("ETH", "bestBuy","TMN"))
                    )}
                    rateChange={getTokenInfo(
                      "ETH",
                      "change24Percentage"
                    ).toFixed(2)}
                    tomanPrice={`$${Number(getTokenInfo("ETH", "bestBuy"))}`}
                    imgSrc={getTokenInfo("ETH", "logoUrl64px")}
                  />
                </div>
                <div className="left-bottom-token-price-card">
                  <PriceCard
                    coinName={getTokenInfo("ADA", "localeName")}
                    tetherPrice={addComma(
                      Number(getTokenInfo("ADA", "bestBuy","TMN"))
                    )}
                    rateChange={getTokenInfo(
                      "ADA",
                      "change24Percentage"
                    ).toFixed(2)}
                    tomanPrice={`$${Number(addComma(
                      getTokenInfo("ADA", "bestBuy"))
                    )}`}
                    imgSrc={getTokenInfo("ADA", "logoUrl64px")}
                  />
                </div>
              </>
            ) : (
              <div className="center-lottie-price-card">
                <LottieLogo options={logoOptions} />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
